import { render, staticRenderFns } from "./AdminEditWohnung.vue?vue&type=template&id=2293d34e&scoped=true&"
import script from "./AdminEditWohnung.vue?vue&type=script&lang=js&"
export * from "./AdminEditWohnung.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditWohnung.vue?vue&type=style&index=0&id=2293d34e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2293d34e",
  null
  
)

export default component.exports